<div [formGroup]="form" class="form-group">

    <mat-form-field>
        <mat-label *ngIf="config.attrs.label">{{config.attrs.label}}</mat-label>
        <mat-select  [formControl]="selectCtrl" [required]="config.attrs.required" placeholder="{{config.attrs.label}}" (selectionChange)="selectChange($event)" [multiple]="config.attrs.multiple">

            <mat-option>
                <ngx-mat-select-search [formControl]="optionFilterCtrl" [placeholderLabel]="'Rechercher...'" [noEntriesFoundLabel]="'Aucun resultat..'" (keyup)="keypressSearch.emit($event)"></ngx-mat-select-search>
            </mat-option>
            <mat-option *ngIf="config.attrs.multiple" disabled="true">Sélectionner une ou plusieurs options</mat-option>
            <mat-option *ngIf="!config.attrs.multiple"></mat-option>
            <mat-option *ngFor="let option of filteredOptions | async" [value]="option.id" [attr.data-cf-mat-option-value]="option.id">
                {{option.name}}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <p *ngIf="config.attrs.help" class="message-help">{{ config.attrs.help }}.</p>

    <mat-error>
        <div *ngIf="form.controls[config.id].invalid && (form.controls[config.id].dirty || form.controls[config.id].touched)">
            <div *ngIf="form.controls[config.id].errors?.required">{{ 'form.validation.error.required' | translate }}</div>
        </div>
    </mat-error>

</div>
